import { render } from "./GupUploadsPage.vue?vue&type=template&id=22121ddc&scoped=true"
import script from "./GupUploadsPage.vue?vue&type=script&lang=js"
export * from "./GupUploadsPage.vue?vue&type=script&lang=js"

import "./GupUploadsPage.vue?vue&type=style&index=0&id=22121ddc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22121ddc"]])

export default __exports__